import { render, staticRenderFns } from "./OffersLoader.vue?vue&type=template&id=69c4df1c&"
import script from "./OffersLoader.vue?vue&type=script&lang=js&"
export * from "./OffersLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports